import { validateNorwegianIdNumber } from "norwegian-national-id-validator";

export enum NameValidationErrorType {
  // values correspond to translations keys "common.errors.invalid.<type>"
  EMPTY = "empty.name",
  MISSING_LAST_NAME = "missing.last.name",
  INVALID_FIRST_NAME = "first.name",
  INVALID_LAST_NAME = "last.name",
}

// a valid name must consists of at least 2 parts - separated by a space - each with a length of at least 2 characters
export const isNameValid = (name?: string): NameValidationErrorType | undefined => {
  if (!name || name.trim().length === 0) {
    return NameValidationErrorType.EMPTY;
  }

  name = name.trim();

  const lastSeparatorIndex = name.lastIndexOf(" ");
  if (lastSeparatorIndex <= 0) {
    if (name.length < 2) {
      return NameValidationErrorType.INVALID_FIRST_NAME;
    } else {
      return NameValidationErrorType.MISSING_LAST_NAME;
    }
  }

  const lastName = name.substr(lastSeparatorIndex + 1);
  if (lastName.length < 2) {
    return NameValidationErrorType.INVALID_LAST_NAME;
  }
};

export const isNationalIdValid = (nationalId?: string) => nationalId && validateNorwegianIdNumber(nationalId);
